import React, { Fragment } from 'react';
import axios from 'axios';
import Qs from 'qs'
import {
    Button} from 'reactstrap';
import { clearSession } from '../../session';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactQuill from 'react-quill';

export default class AboutUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = { about_us: {image:"",info_ch:"", info_en:"", title_ch:"",title_en:""}, lang:"EN" };
    }
    componentDidMount() {
        let session = window.localStorage;
        axios.post(session.ch_action_url + "/action/get_home_about_us", Qs.stringify({
            token: session.ch_admin_token
        })).then(res => {
            if (res.data.status === -1) {
                clearSession();
            }
            else if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
            }
            else {
                let about_us = res.data.data;
                this.setState({ about_us: about_us });
            }
        });
    }


    handleUpdateInfo() {
        let session = window.localStorage;
        let title=document.getElementById("about_us_title").value;
        let introduction=this.state.lang==="CH"?this.state.about_us.info_ch:this.state.about_us.info_en;
        axios.post(session.ch_action_url + "/action/update_about_us_info", Qs.stringify({
            token: session.ch_admin_token,
            lang:this.state.lang,
            title:title,
            intro:introduction
        })).then(res => {
            if (res.data.status === -1) {
                clearSession();
            }
            else if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
            }
            else {
                let about_us=this.state.about_us;
                if(this.state.lang==="EN")
                {
                    about_us.info_en=introduction;
                    about_us.title_en=title;
                }
                else
                {
                    about_us.info_ch=introduction;
                    about_us.title_ch=title;
                }
                this.setState({ about_us: about_us });
                Swal.fire(
                    'Good Job!',
                    "Information has been saved!",
                    'success');
            }
        });
    }

    handleAddNewImage() {
        let final_this=this;
        let fileInput = document.getElementById('upload_about_us_image');
        if (fileInput.files != null && fileInput.files.length === 1) {
            let reader = new FileReader();
            reader.onload = function (e) {
                let image = new Image();
                image.src = e.target.result;
                image.onload = function () {
                    let height = this.height;
                    let width = this.width;
                    // while (width >= 1080 || height >= 1080) {
                    //     height = height / 2;
                    //     width = width / 2;
                    // }
                    let mainCanvas = document.createElement("canvas");
                    mainCanvas.width = 458;
                    mainCanvas.height = 368;
                    var ctx = mainCanvas.getContext("2d");
                    ctx.drawImage(image, 0, 0, mainCanvas.width, mainCanvas.height);
                    let image_64 = mainCanvas.toDataURL("image/jpeg");
                    mainCanvas.remove();
                    let session = window.localStorage;

                    axios.post(session.ch_action_url + "/action/update_about_us_image", Qs.stringify({
                        token: session.ch_admin_token,
                        src: image_64
                    })).then(res => {
                        if (res.data.status === -1) {
                            clearSession();
                        }
                        else if (res.data.status === 0) {
                            Swal.fire(
                                'Operation Failed!',
                                res.data.info,
                                'error');
                        }
                        else {
                            let about_us = final_this.state.about_us;
                            about_us.image=image_64;
                            
                            final_this.setState({ about_us: about_us });
                        }
                    });
                };
                fileInput.value = "";
            };
            reader.readAsDataURL(fileInput.files[0]);
        }
        else {
            Swal.fire(
                'Operation Failed!',
                "You have not select image!",
                'error');
            return;
        }
    }

    handleShowUploadImage() {
        let fileInput = document.getElementById('upload_about_us_image');
        fileInput.click();
    }

    handleUpdateLang(value)
    {
        if(value==="EN")
        {
            document.getElementById("about_us_title").value=this.state.about_us.title_en;
            //document.getElementById("about_us_intro").value=this.state.about_us.info_en;
        }
        else{
            document.getElementById("about_us_title").value=this.state.about_us.title_ch;
            //document.getElementById("about_us_intro").value=this.state.about_us.info_ch;
        }
        this.setState({lang:value});
    }

    handleUpdateIntroduction(value)
    {
        let about_us=this.state.about_us;
        if(this.state.lang==="CH")
        {
            about_us.info_ch=value;
        }
        else
        {
            about_us.info_en=value;
        }
        this.setState({about_us:about_us});

    }

    render() {
        return <Fragment>
            <div className="p-2 pl-2 pr-4">
                <input type="file" style={{ display: "none" }} id="upload_about_us_image" accept="image/png, image/gif,image/jpg, image/jpeg, image/bmp, image/x-icon" onChange={(e) => this.handleAddNewImage()} />
                <div className="mb-3 mt-2 card p-2" style={{ maxWidth: "800px", margin: "auto" }}>
                    
                    <div className="p-2 text-center" style={{ cursor: "pointer" }}>
                        <div style={{ width: "100%" }} className="text-center align-items-center">
                            <span className="mr-2">{"The image of us"}</span>
                            <FontAwesomeIcon icon={['fas', 'edit']} onClick={(e) => this.handleShowUploadImage()} />
                        </div>
                        <img src={this.state.about_us.image} style={{ maxWidth: "100%", minHeight: "300px", height: "300px", minWidth: "200px" }} onClick={(e) => this.handleShowUploadImage()} />
                    </div>

                    <div className="d-flex">
                        <Button size="sm" className="form-control" color="first" onClick={e => this.handleUpdateInfo()}>Save</Button>
                    </div>

                    <div className="form-group">
                        <label for="about_us_lang">Language</label>
                        <select className="form-control" id="about_us_lang" defaultValue={this.state.lang} onChange={(e)=>this.handleUpdateLang(e.target.value)}>
                            <option value="CH">CH</option>
                            <option value="EN">EN</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label for="about_us_title">Title</label>
                        <input type="text" className="form-control" id="about_us_title" defaultValue={this.state.lang==="CH"?this.state.about_us.title_ch:this.state.about_us.title_en} />
                    </div>
                    <div className="form-group">
                        <label for="about_us_intro">Introduction</label>
                        <ReactQuill theme="snow" value={this.state.lang==="CH"?this.state.about_us.info_ch:this.state.about_us.info_en} onChange={(value)=>this.handleUpdateIntroduction(value)} placeholder="Example placeholder..."/>
                    </div>

                </div>
            </div>
        </Fragment>
    }

}